const styles = theme => ({
    container: {
        height: '32px',
        minWidth: '61px',
        borderRadius: '16px',
        backgroundColor: props => props.showBackground && 'rgba(0,0,0,0.5)',
        display: 'inline-block',
    },
    text: {
        color: '#FFFFFF',
        float: 'left',
        marginTop: '5px',
        marginLeft: '10px',
        marginRight: '12px',
        fontFamily: theme.typography.fontFamily,
    },
    iconContainer: {
        width: '32px',
        height: '32px',
        float: 'right',
        borderRadius: '16px',
        background: 'rgba(0,0,0,0.30)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
    },
})

export default styles
